import { render } from "./ProductPriceInsertMix.vue?vue&type=template&id=05623987"
import script from "./ProductPriceInsertMix.vue?vue&type=script&lang=js"
export * from "./ProductPriceInsertMix.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__